import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {VnaCampaignService} from '../../services/vna-campaign.service';
import {AuthService} from '../../../../../core/service/auth.service';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {VnaPortalSelected} from '../../../../../core/data/messaging/VnaPortalSelected';
import {VnaCampaignSelected} from '../../model/vna_campaign_selected';

const SELECT_VNA_CAMPAIGN_VALUE_ACCESSOR: any = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectVnaCampaignComponent)
};

@Component({
    selector: 'app-select-vna-campaign',
    template: `
      <ngx-select [items]="campaigns" [(ngModel)]="campaign" [optionValueField]="valueField" [optionTextField]="textField" (select)="selected($event)" allowClear="true">
          <ng-template ngx-select-option ngx-select-option-selected let-option let-text="text">
              {{ option.data.name }} <br />
          </ng-template>
      </ngx-select>
      `,
    styleUrls: ['./select-vna-campaign.component.scss'],
    providers: [SELECT_VNA_CAMPAIGN_VALUE_ACCESSOR]
})
export class SelectVnaCampaignComponent implements OnInit, ControlValueAccessor {

    @Input() valueField: string = 'pk';
    @Input() textField: string = 'name';
    @Output() campChanged = new EventEmitter();

    campaigns: Array<Object> = [];
    _campaign: number;

    constructor(private campHandler: VnaCampaignService, private messaging: MessagingService, private auth: AuthService) { }

    ngOnInit() {
        this.campHandler.findPortalCampaigns(this.auth.getPkPortal()).subscribe(
            (result) => {
                this.campaigns = result;
                this.filterCampaigns();
            }
        );

        this.messaging.message.subscribe(
            (value) => {
                if(value instanceof VnaPortalSelected && !value.isTheFirst()){
                    this.campHandler.findPortalCampaigns(value.getPkPortal()).subscribe(
                        (result) => {
                            this.campaigns = result;
                            this.filterCampaigns();
                        }
                    )
                }
            }
        )

    }

    protected filterCampaigns(): void {
      const pkClient = this.auth.getClient();
      if(pkClient > 0){
        this.campaigns = this.campaigns.filter( (camp: any) => {
          return camp['client_pk'] === pkClient;
        })
      }
    }


    selected(value: any) {
        this.messaging.sendMessage(new VnaCampaignSelected(value));
        this.propagateChange(this._campaign);
    }


    get campaign(): any { return this._campaign; };

    set campaign(v: any) {
        this._campaign = v;
        this.campChanged.emit(v);
        this.propagateChange(this._campaign);
    }

    propagateChange = (_: any) => {};

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
    }

    writeValue(value: any): void {
        this._campaign = value;
    }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/components/select-vna-campaign/select-vna-campaign.component.ts